module.exports = "<div data-bind=\"html: params.params.modalBodyText\"></div>";